import * as React from 'react';

export function OngStandard() {
  return (
    <section className="ong-standard">
      <style>{`
        .ong-standard {
          padding: 72px 24px;
          background: #fff;
        }
        .ong-standard-inner {
          max-width: 720px;
          margin: 0 auto;
        }
        .ong-standard h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 8px;
        }
        .ong-standard .subtitle {
          font-size: 18px;
          color: #666;
          margin: 0 0 32px;
        }
        .ong-checklist {
          list-style: none;
          padding: 0;
          margin: 0 0 28px;
        }
        .ong-checklist li {
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 14px 18px;
          font-size: 16px;
          color: #333;
          font-weight: 500;
          border-radius: 10px;
          margin-bottom: 8px;
          background: #f0fdf0;
        }
        .ong-checklist li i {
          color: #1EAA25;
          font-size: 18px;
          flex-shrink: 0;
        }
        .ong-standard .closing {
          font-size: 16px;
          color: #555;
          font-style: italic;
          margin: 0;
        }
        @media (max-width: 640px) {
          .ong-standard h2 {
            font-size: 24px;
          }
        }
      `}</style>
      <div className="ong-standard-inner">
        <h2>Lo que garantizamos</h2>
        <p className="subtitle">Pensado para organizaciones que necesitan estirar cada peso</p>
        <ul className="ong-checklist">
          <li><i className="fa fa-check-circle" /> Productos frescos y de temporada</li>
          <li><i className="fa fa-check-circle" /> Entrega programada y puntual</li>
          <li><i className="fa fa-check-circle" /> Precios estables y transparentes</li>
          <li><i className="fa fa-check-circle" /> Pedido online las 24 hs</li>
          <li><i className="fa fa-check-circle" /> Facturación formal para rendiciones y auditorías</li>
        </ul>
        <p className="closing">No entregamos lo que no pondríamos en la mesa de nuestra propia familia.</p>
      </div>
    </section>
  );
}
